import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Rating from "@mui/material/Rating";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import request from "src/utils/request";
import { useEffect } from "react";
import { Stack } from "@mui/material";

const StyledRating = styled(Rating)(({ theme }) => ({
    "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
        color: theme.palette.action.disabled,
    },
}));

const customIcons = {
    1: {
        icon: (
            <ThumbUpAltIcon
                color="success"
                fontSize="small"
                style={{ marginRight: "3px", marginLeft: "3px" }}
            />
        ),
        label: "Very Dissatisfied",
    },
    2: {
        icon: (
            <ThumbDownAltIcon
                color="warning"
                fontSize="small"
                style={{ marginRight: "3px", marginLeft: "3px" }}
            />
        ),
        label: "Dissatisfied",
    },
};

const IconContainer = (props) => {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
};

IconContainer.propTypes = {
    value: PropTypes.number.isRequired,
};

const AdvancedInsightsRadioGroupRating = ({
    id,
    existingReaction,
    thumbsUpsCount,
    thumbsDownsCount,
}) => {
    const [value, setValue] = React.useState(null);

    useEffect(() => {
        if (existingReaction === "up") setValue(1);
        if (existingReaction === "down") setValue(2);
    }, [existingReaction]);

    const handleRatingChange = async (action, reaction) => {
        await request(`api/data/v1/insights/react/${id}`, {
            method: "PUT",
            body: JSON.stringify({ action, reaction }),
        });
    };

    const getActualUpCount = () => {
        if (existingReaction === "up") {
            if (value !== 1) return thumbsUpsCount - 1;
            return thumbsUpsCount;
        }
        if (value === 1) return thumbsUpsCount + 1;
        return thumbsUpsCount;
    };

    const getActualDownCount = () => {
        if (existingReaction === "down") {
            if (value !== 2) return thumbsDownsCount - 1;
            return thumbsDownsCount;
        }
        if (value === 2) return thumbsDownsCount + 1;
        return thumbsDownsCount;
    };

    const upCount = getActualUpCount();
    const downCount = getActualDownCount();

    return (
        <Stack direction="row" alignItems="center">
            {upCount > 0 && <span style={{ fontSize: "10px" }}>+{upCount}</span>}
            <StyledRating
                name="highlight-selected-only"
                IconContainerComponent={IconContainer}
                getLabelText={(v) => customIcons[v].label}
                max={2}
                highlightSelectedOnly
                onChange={(_e, v) => {
                    setValue(v);
                    handleRatingChange(
                        v !== null ? "add" : "remove",
                        (v || value) === 1 ? "up" : "down"
                    );
                }}
                value={value}
            />
            {downCount > 0 && <span style={{ fontSize: "10px" }}>-{downCount}</span>}
        </Stack>
    );
};

export default AdvancedInsightsRadioGroupRating;
